import env from '../../../config/env';
import { errorGQLHandler } from '../../../helpers/helpers';
import MIDIA_PRINCIPAL from '../../../graphql/revista/queries/MidiaPrincipal.gql';
import MIDIA_VIVO_EM_PAUTA from '../../../graphql/revista/queries/MidiaVivoEmPauta.gql';
import MIDIA_VIVO_INFORMATIVO from '../../../graphql/revista/queries/MidiaVivoInformativo.gql';

const SET_MIDIA_PRINCIPAL = 'SET_MIDIA_PRINCIPAL';
const SET_MIDIA_VIVO_EM_PAUTA = 'SET_MIDIA_VIVO_EM_PAUTA';
const SET_MIDIA_VIVO_INFORMATIVO = 'SET_MIDIA_VIVO_INFORMATIVO';
const CHANGE_STATUS_POPUP = 'CHANGE_STATUS_POPUP';
const RESET_MIDIA_PRINCIPAL = 'RESET_MIDIA_PRINCIPAL';
const RESET_MIDIA_VIVO_EM_PAUTA = 'RESET_MIDIA_VIVO_EM_PAUTA';
const RESET_MIDIA_VIVO_INFORMATIVO = 'RESET_MIDIA_VIVO_INFORMATIVO';

export default {
  namespaced: true,
  state: {
    popupName: '@popup',
    principal: {
      paginate: 5,
      midias: [],
    },
    vivoEmPauta: {},
    vivoInformativo: {
      popup: false,
      midia: {},
    },
  },
  getters: {
    principal: state => state.principal.midias,
    vivoEmPauta: state => state.vivoEmPauta,
    informativo: state => state.vivoInformativo.midia,
    popup: state => state.vivoInformativo.popup,
  },
  mutations: {
    [SET_MIDIA_PRINCIPAL](state, payload) {
      payload.map(item => state.principal.midias.push(item));
    },
    [SET_MIDIA_VIVO_EM_PAUTA](state, payload) {
      state.vivoEmPauta = payload;
    },
    [SET_MIDIA_VIVO_INFORMATIVO](state, payload) {
      state.vivoInformativo.midia = payload;
    },
    [RESET_MIDIA_PRINCIPAL](state) {
      state.principal.midias = [];
    },
    [RESET_MIDIA_VIVO_EM_PAUTA](state) {
      state.vivoEmPauta = {};
    },
    [RESET_MIDIA_VIVO_INFORMATIVO](state) {
      state.vivoInformativo.midias = {};
    },
    [CHANGE_STATUS_POPUP](state, bool) {
      bool
        ? document.body.setAttribute('style', 'overflow: hidden')
        : document.body.removeAttribute('style');
      state.vivoInformativo.popup = bool;
    },
  },
  actions: {
    getMidiaPrincipal({ rootGetters, state, commit }) {
      commit(RESET_MIDIA_PRINCIPAL);
      const uf = rootGetters['user/uf'];
      if (!uf) return;
      env.apollo
        .query({
          query: MIDIA_PRINCIPAL,
          variables: {
            modulo: env.revista.modulo,
            uf,
            tipoMidia: 'banner_principal',
            paginate: state.principal.paginate,
            canal: env.revista.canal,
          },
          fetchPolicy: 'no-cache',
        })
        .then(response => {
          const { data } = response.data.midia;
          commit(SET_MIDIA_PRINCIPAL, data);
        })
        .catch(e => errorGQLHandler(e));
    },
    getMidiaVivoEmPauta({ rootGetters, commit }) {
      commit(RESET_MIDIA_VIVO_EM_PAUTA);
      const uf = rootGetters['user/uf'];
      if (!uf) return;
      env.apollo
        .query({
          query: MIDIA_VIVO_EM_PAUTA,
          variables: {
            modulo: env.revista.modulo,
            uf,
            tipoMidia: 'pauta',
            paginate: 1,
          },
          fetchPolicy: 'no-cache',
        })
        .then(response => {
          const {
            data: [banner],
          } = response.data.midia;
          commit(SET_MIDIA_VIVO_EM_PAUTA, banner);
        })
        .catch(e => errorGQLHandler(e));
    },
    async getMidiaVivoInformativo({ rootGetters, dispatch, commit }) {
      const userUF = rootGetters['user/uf'];
      if (!userUF) return;
      const query = await env.apolloRevista.query({
        query: MIDIA_VIVO_INFORMATIVO,
        variables: {
          modulo: env.revista.modulo,
          uf: userUF,
          tipoMidia: 'banner_vivo',
          paginate: 1,
        },
        fetchPolicy: 'no-cache',
      });
      try {
        const {
          data: [banner],
        } = query.data.midia;
        if (banner) {
          const exists = await await dispatch('findSessionStorage', banner.id);
          try {
            if (!exists) {
              await dispatch('saveLocalStorage', banner.id);
              commit(SET_MIDIA_VIVO_INFORMATIVO, banner);
              dispatch('changeStatusPopup', true);
            }
          } catch (e) {
            console.log(`Erro sessionStorage: ${e}`);
          }
        }
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    async findSessionStorage({ state, rootGetters }, id) {
      const { popupName } = state;
      const uf = rootGetters['user/uf'];
      const { token } = env;
      const store = await window.sessionStorage.getItem(`${popupName}::${id}:${uf}:${token}`);
      return store;
    },
    async saveLocalStorage({ state, rootGetters }, id) {
      const { popupName } = state;
      const uf = rootGetters['user/uf'];
      const { token } = env;
      const store = await window.sessionStorage.setItem(`${popupName}::${id}:${uf}:${token}`, true);
      return store;
    },
    changeStatusPopup({ commit }, bool) {
      commit(CHANGE_STATUS_POPUP, bool);
    },
  },
};
